import React, { useState, useEffect, useRef } from 'react';
import {
  DownloadIcon,
  CopyIcon,
  CloseIcon,
  SearchIcon,
  PaintIcon,
} from '../Icon';
import { copyToClipboard } from '../../tools/copy';
import { downloadText, downloadSVGtoPNG } from '../../tools/download';
import { sortIconById } from '../../tools/tools';
import message from 'rc-message';
import { ChromePicker } from 'react-color';
import { formatSvg } from '../../tools/formatSvg';
import 'rc-message/assets/index.css';
import './index.scss';

export const MIconsList = ({ data = [] }) => {
  const [filters, setFilters] = useState({
    keywords: '',
  });
  const [detailIcon, setDetailIcon] = useState({ visable: false, icon: null });
  const [color, setColor] = useState('#0052D9');
  const [colorpicker, setColorpicker] = useState(false);
  const [fixed, setFixed] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const inputRef = useRef(null);

  const icons = filterIcons(data, filters);
  const validColor = /(#[abcdef0-9]{6})/gi.test(color);
  const svg =
    detailIcon.icon && validColor
      ? unescape(detailIcon.icon.source_code).replace(
        /(#[abcdef0-9]{6})/gi,
        color
      )
      : detailIcon.icon
        ? unescape(detailIcon.icon.source_code)
        : '';
  const handleCopySVG = async () => {
    if (svg === '') {
      return;
    }
    await copyToClipboard(svg);
    message.success({ content: '复制成功 ！' });
  };

  const handleScroll = (e) => {
    const domInput = inputRef.current;
    const { top, bottom } = domInput.getBoundingClientRect();
    if (top < 0 && bottom > 860) {
      if (fixed === false) {
        setFixed(true);
      }
    } else {
      if (fixed === true) {
        setFixed(false);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('click', () => {
      if (colorpicker) {
        setColorpicker(false);
      }
    });
  }, [colorpicker]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [fixed]);

  return (
    <>
      <div
        className={
          fixed ? 'material-search material-search--fixed' : 'material-search'
        }
        ref={inputRef}
      >
        <div className="material-search-hd">
          <div className="material-search-hd-main">
            <div className="material-searchlabel">
              <div className="material-search-main">
                <div className="ms-prefix">
                  <SearchIcon />
                </div>
                <input
                  type="text"
                  className="ms-input"
                  placeholder="搜索腾讯云产品图标"
                  value={filters.keywords}
                  onChange={(e) =>
                    setFilters({ ...filters, keywords: e.target.value })
                  }
                />
                {!!filters.keywords && (
                  <span
                    className="ms-tail"
                    onClick={() => setFilters({ ...filters, keywords: '' })}
                  >
                    <CloseIcon />
                  </span>
                )}
              </div>
            </div>
            <div className="material-searchcolor">
              <div className="ms-colorpicker">
                颜色定制：
                <div
                  className="ms-colorpicker-main"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setColorpicker(!colorpicker);
                  }}
                >
                  <i
                    className="ms-colorpicker-shower"
                    style={{ background: color }}
                  ></i>
                  <i className="ms-colorpicker-pointer">
                    <PaintIcon />
                  </i>
                  {colorpicker && (
                    <div
                      className="ms-colorpicker-popover"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                      }}
                    >
                      <ChromePicker
                        onChangeComplete={(color) => {
                          setColor(color.hex);
                        }}
                        color={color}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="material-search-bd">
          {filters.keywords && (
            <h3 className="material-search-keywrods">{`搜索 “${filters.keywords}” 的结果：`}</h3>
          )}
          <div className="material-search-list">
            {sortIconById(icons).map((icon, index) => {
              if (!showAll && index > 41) {
                return null;
              }
              return (
                <div
                  className="material-search-item"
                  onClick={() => setDetailIcon({ visable: true, icon })}
                  key={icon.key}
                >
                  <SvgIcon svgCode={unescape(icon.source_code).replace(
                      /(#[abcdef0-9]{6})/gi,
                      color
                    )}></SvgIcon>
                  {/* <span
                    className="material-search-itemsvg"
                    code={color}
                  >
                    <svg-icon code={unescape(icon.source_code).replace(
                      /(#[abcdef0-9]{6})/gi,
                      color
                    )}>{color}</svg-icon>
                  </span> */}
                  <span className="material-search-itemname">
                    {icon.c_name}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
        <div className="material-search-ft">
          {!showAll && !filters.keywords && (
            <span className="showmore-btn" onClick={() => setShowAll(true)}>
              查看全部
            </span>
          )}
        </div>
      </div>
      {detailIcon.visable && (
        <div className="material-searchmodal">
          <div
            className="material-searchmodal-shadow"
            onClick={() => setDetailIcon({ visable: false, icon: null })}
          ></div>
          <div className="material-searchmodal-main">
            <span
              className="material-searchmodal-close"
              onClick={() => setDetailIcon({ visable: false, icon: null })}
            >
              <CloseIcon />
            </span>
            <div className="material-searchmodal-icondetail">
              <div className="icondetail-hd">
                <div
                  className="icondetail-icon"
                  dangerouslySetInnerHTML={{
                    __html: formatSvg(svg),
                  }}
                ></div>
              </div>
              <div className="icondetail-bd">
                <p className="icondetail-title">{detailIcon.icon.c_name}</p>
                <p className="icondetail-subname">
                  缩略名： {detailIcon.icon.e_name || '---'}
                </p>
                <p className="icondetail-subname">
                  尺寸： {detailIcon.icon.size}px
                </p>
                <p className="icondetail-subname">颜色：{color}</p>
                <div className="icondetail-actions">
                  <button
                    className="icondetail-btn icondetail-btn--primary"
                    onClick={() => downloadText(svg, detailIcon.icon.o_name)}
                  >
                    <DownloadIcon className="icondetail-btn-icon" />
                    <span className="icondetail-btn-text">SVG</span>
                  </button>
                  <button
                    className="icondetail-btn icondetail-btn--primary"
                    onClick={() =>
                      downloadSVGtoPNG(svg, detailIcon.icon.c_name)
                    }
                  >
                    <DownloadIcon className="icondetail-btn-icon" />
                    <span className="icondetail-btn-text">PNG</span>
                  </button>
                  <button
                    className="icondetail-btn icondetail-btn--primary"
                    onClick={handleCopySVG}
                  >
                    <CopyIcon className="icondetail-btn-icon" />
                    <span className="icondetail-btn-text">Copy SVG</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const filterIcons = (data = [], filters) => {
  let icons = data;
  const lowerCaseKey = filters.keywords.toLowerCase();
  const getAcronym = (str) => { // 英文名缩写
    return str
        .split(' ')
        .map(word => word.charAt(0).toUpperCase())
        .join('');
  };

  return icons.filter(item => {
    return (
        item.c_name.includes(filters.keywords) ||
        item.e_name.toLowerCase().includes(lowerCaseKey) ||
        item.e_tag.toLowerCase().includes(lowerCaseKey) ||
        getAcronym(item.e_name).includes(filters.keywords.toUpperCase())
    );
  });
};

function SvgIcon({svgCode}) {
  const code = formatSvg(svgCode);
  return (
    <span
      className="material-search-itemsvg"
    >
      <svg-icon code={code}></svg-icon>
    </span>
  )
}